module.exports = __webpack_public_path__ + "static/media/NotoSansJP-Medium.7aa0d112.ttf";